import React, { useState } from 'react';

const AgendaModule = () => {
  const [activeTab, setActiveTab] = useState('agenda');

  const reunions = [
    { id: 1, titre: "CODIR Juin 2026", type: "codir", date: "2026-06-15", heure: "09:00", lieu: "Salle de réunion", participants: ["DG", "DAF", "Chef Compta"], statut: "a_venir" },
    { id: 2, titre: "Point équipe comptabilité", type: "equipe", date: "2026-06-18", heure: "14:00", lieu: "Bureau comptabilité", participants: ["Chef Compta", "Équipe"], statut: "a_venir" },
    { id: 3, titre: "Formation SYSCOHADA", type: "formation", date: "2026-06-20", heure: "10:00", lieu: "Salle formation", participants: ["Tous"], statut: "a_venir" },
  ];

  const rendezVous = [
    { id: 1, titre: "Client Mairie Cotonou", type: "commercial", date: "2026-06-10", heure: "14:00", lieu: "Mairie", contact: "M. AZONHIHO", statut: "confirme" },
    { id: 2, titre: "Banque SGBBE", type: "institutionnel", date: "2026-06-12", heure: "11:00", lieu: "Agence bancaire", contact: "Conseiller", statut: "a_confirmer" },
    { id: 3, titre: "Fournisseur Papeterie", type: "commercial", date: "2026-06-14", heure: "15:30", lieu: "Boutique", contact: "M. DOSSA", statut: "confirme" },
  ];

  const decisions = [
    { id: 1, decision: "Mise en place nouveau logiciel comptable", responsable: "Chef Compta", echeance: "2026-07-01", priorite: "haute", statut: "en_cours" },
    { id: 2, decision: "Formation équipe sur TVA", responsable: "Chef Compta", echeance: "2026-06-30", priorite: "normale", statut: "en_cours" },
    { id: 3, decision: "Archivage documents 2023", responsable: "Aide-Comptable", echeance: "2026-06-15", priorite: "haute", statut: "fait" },
  ];

  return (
    <div style={{ padding: '20px 24px', background: '#060d18', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 24, fontWeight: 600, color: '#fff', marginBottom: 4 }}>
          📅 Agenda · Réunions · Rendez-vous
        </h1>
        <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.42)' }}>
          Planning · CODIR · PV · Décisions · Contacts externes
        </p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 2, borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: 20 }}>
        {[
          { id: 'agenda', icon: '📅', label: 'Agenda', badge: reunions.length + rendezVous.length },
          { id: 'reunions', icon: '🤝', label: 'Réunions', badge: reunions.length },
          { id: 'pv', icon: '📄', label: 'PV & Comptes rendus', badge: 3 },
          { id: 'rdv', icon: '🎯', label: 'Rendez-vous', badge: rendezVous.length },
          { id: 'decisions', icon: '✅', label: 'Décisions', badge: decisions.filter(d => d.statut !== 'fait').length }
        ].map(tab => (
          <div
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '11px 18px',
              fontSize: 12,
              color: activeTab === tab.id ? '#C9A84C' : '#667',
              cursor: 'pointer',
              borderBottom: activeTab === tab.id ? '2px solid #C9A84C' : '2px solid transparent',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}
          >
            {tab.icon} {tab.label}
            <span style={{
              fontSize: 9,
              fontWeight: 700,
              padding: '1px 5px',
              borderRadius: 99,
              background: 'rgba(201,168,76,0.2)',
              color: '#C9A84C'
            }}>
              {tab.badge}
            </span>
          </div>
        ))}
      </div>

      {/* Content */}
      {activeTab === 'reunions' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>🤝</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#fff' }}>{reunions.length}</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Total réunions</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>📅</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#42a5f5' }}>
                {reunions.filter(r => r.statut === 'a_venir').length}
              </div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>À venir</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>✅</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#66bb6a' }}>0</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Tenues</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>⏱️</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#C9A84C' }}>—</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Heures</div>
            </div>
          </div>

          <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 11, padding: '16px 18px' }}>
            <h3 style={{ fontSize: 12, fontWeight: 600, color: '#fff', marginBottom: 14 }}>🤝 Toutes les réunions planifiées</h3>
            {reunions.map(reunion => (
              <div key={reunion.id} style={{
                background: '#0f1e2e',
                border: '1px solid rgba(255,255,255,0.06)',
                borderRadius: 12,
                padding: '16px 18px',
                marginBottom: 12,
                display: 'flex',
                gap: 16,
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}>
                <div style={{ textAlign: 'center', flexShrink: 0, minWidth: 56 }}>
                  <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 20, fontWeight: 600, color: '#ce93d8', lineHeight: 1 }}>
                    {reunion.heure}
                  </div>
                  <div style={{ fontSize: 9, color: '#556', marginTop: 3 }}>{reunion.date}</div>
                </div>
                <div style={{ width: 3, borderRadius: 99, background: '#7b1fa2', alignSelf: 'stretch' }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{reunion.titre}</div>
                  <div style={{ display: 'flex', gap: 12, fontSize: 10, color: '#667', marginBottom: 8 }}>
                    <span>📍 {reunion.lieu}</span>
                    <span>👥 {reunion.participants.join(', ')}</span>
                  </div>
                  <span style={{
                    fontSize: 9,
                    padding: '2px 8px',
                    borderRadius: 99,
                    background: 'rgba(123,31,162,0.15)',
                    color: '#ce93d8'
                  }}>
                    {reunion.type.toUpperCase()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'rdv' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>🎯</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#fff' }}>{rendezVous.length}</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Total RDV</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>✅</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#66bb6a' }}>
                {rendezVous.filter(r => r.statut === 'confirme').length}
              </div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Confirmés</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>⏳</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#ffb74d' }}>
                {rendezVous.filter(r => r.statut === 'a_confirmer').length}
              </div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>En attente</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>📊</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#42a5f5' }}>—</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Avec CR</div>
            </div>
          </div>

          <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 11, padding: '16px 18px' }}>
            <h3 style={{ fontSize: 12, fontWeight: 600, color: '#fff', marginBottom: 14 }}>🎯 Rendez-vous Externes</h3>
            {rendezVous.map(rdv => (
              <div key={rdv.id} style={{
                background: '#0f1e2e',
                border: '1px solid rgba(255,255,255,0.06)',
                borderRadius: 12,
                padding: '16px 18px',
                marginBottom: 10,
                display: 'flex',
                gap: 14,
                cursor: 'pointer'
              }}>
                <div style={{ textAlign: 'center', flexShrink: 0 }}>
                  <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 20, fontWeight: 600, color: '#C9A84C' }}>
                    {rdv.heure}
                  </div>
                  <div style={{ fontSize: 9, color: '#556', marginTop: 2 }}>{rdv.date}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{rdv.titre}</div>
                  <div style={{ fontSize: 10, color: '#667', marginBottom: 6 }}>
                    📍 {rdv.lieu} · 👤 {rdv.contact}
                  </div>
                  <span style={{
                    fontSize: 9,
                    padding: '2px 8px',
                    borderRadius: 99,
                    background: rdv.statut === 'confirme' ? 'rgba(67,160,71,0.15)' : 'rgba(251,140,0,0.18)',
                    color: rdv.statut === 'confirme' ? '#66bb6a' : '#ffb74d'
                  }}>
                    {rdv.statut === 'confirme' ? '✅ Confirmé' : '⏳ À confirmer'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'decisions' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>✅</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#66bb6a' }}>
                {decisions.filter(d => d.statut === 'fait').length}
              </div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Exécutées</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>🔄</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#42a5f5' }}>
                {decisions.filter(d => d.statut === 'en_cours').length}
              </div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>En cours</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>🚨</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#ef5350' }}>0</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>En retard</div>
            </div>
            <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ fontSize: 18, marginBottom: 6 }}>📊</div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#C9A84C' }}>
                {Math.round(decisions.filter(d => d.statut === 'fait').length / decisions.length * 100)}%
              </div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Taux exécution</div>
            </div>
          </div>

          <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 11, padding: '16px 18px' }}>
            <h3 style={{ fontSize: 12, fontWeight: 600, color: '#fff', marginBottom: 14 }}>
              📋 Registre des décisions <span style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)', background: 'rgba(255,255,255,0.05)', padding: '2px 7px', borderRadius: 99, marginLeft: 6 }}>{decisions.length} décisions</span>
            </h3>
            {decisions.map(decision => (
              <div key={decision.id} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 11,
                padding: '12px 0',
                borderBottom: '1px solid rgba(255,255,255,0.04)'
              }}>
                <div style={{
                  width: 18,
                  height: 18,
                  borderRadius: 5,
                  border: decision.statut === 'fait' ? 'none' : '1.5px solid #445',
                  background: decision.statut === 'fait' ? '#43a047' : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 9,
                  color: '#fff',
                  flexShrink: 0,
                  marginTop: 1,
                  cursor: 'pointer'
                }}>
                  {decision.statut === 'fait' && '✓'}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, color: decision.statut === 'fait' ? '#445' : '#ccc', lineHeight: 1.3, textDecoration: decision.statut === 'fait' ? 'line-through' : 'none' }}>
                    {decision.decision}
                  </div>
                  <div style={{ fontSize: 10, color: '#556', marginTop: 3, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <span>👤 {decision.responsable}</span>
                    <span>📅 {decision.echeance}</span>
                    <span style={{
                      fontSize: 9,
                      padding: '1px 6px',
                      borderRadius: 99,
                      background: decision.priorite === 'haute' ? 'rgba(229,57,53,0.15)' : 'rgba(21,101,192,0.15)',
                      color: decision.priorite === 'haute' ? '#ef8080' : '#64b5f6'
                    }}>
                      {decision.priorite === 'haute' ? '🔴 Haute' : '🔵 Normale'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AgendaModule;
